import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { getCompanyLocations } from 'actions/Locations/getCompanyLocations';
import {
  clearPackagesOverview,
  getPackagesUnsentWithShipments,
} from 'actions/Packages/packagesOverviewList';
import { clearShipmentDetailsAction, getShipment } from 'actions/Shipments/shipmentDetails';
import {
  clearShipmentPackagesList,
  shipmentPackagesList,
} from 'actions/Shipments/shipmentPackagesList';
import { updateShipment } from 'actions/Shipments/updateShipment';
import { openModal, closeModal } from 'actions/shared/modal';
import { showSnackbar } from 'actions/shared/snackbar';

import { UpdateShipment } from './UpdateShipment';

const mapStateToProps = state => ({
  auth: state.auth,
  companyLocations: state.companyLocations,
  modal: state.modal,
  packagesOverviewList: state.packagesOverviewList,
  shipmentDetails: state.shipmentDetails,
  shipmentPackagesListData: state.shipmentPackagesListData,
});

const mapDispatchToProps = {
  clearPackagesOverview,
  clearShipmentDetailsAction,
  clearShipmentPackagesList,
  closeModal,
  getCompanyLocations,
  getPackagesUnsentWithShipments,
  getShipment,
  openModal,
  shipmentPackagesList,
  showSnackbar,
  updateShipment,
};

const ConnectedUpdateShipment = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UpdateShipment),
);

export { ConnectedUpdateShipment };
